<script src="../../../shared/interface/commission-redirection.ts"></script>
<app-breadcrumb [master]="'Struktura sieci'" [parentName]="'Placówki'" [name]="'Lista'"></app-breadcrumb>
<div class="facilities-list-container">
  <form (keyup.enter)="filter()" (submit)="filter()" #filtersForm="ngForm" class="facilities-list-filters">
    <mat-form-field class="facilities-list-filter">
      <mat-label>ID</mat-label>
      <input matInput placeholder="12345" name="recordId" [(ngModel)]="initialFilters.recordId">
    </mat-form-field>

    <mat-form-field class="facilities-list-filter">
      <mat-label>Ulica</mat-label>
      <input matInput placeholder="Jana Pawła II" name="contains$street" [(ngModel)]="initialFilters.contains$street">
    </mat-form-field>

    <mat-form-field class="facilities-list-filter">
      <mat-label>Numer budynku</mat-label>
      <input matInput placeholder="12G" name="houseNumber" [(ngModel)]="initialFilters.houseNumber">
    </mat-form-field>

    <mat-form-field class="facilities-list-filter">
      <mat-label>Numer mieszkania</mat-label>
      <input matInput placeholder="135" name="apartmentNumber" [(ngModel)]="initialFilters.apartmentNumber">
    </mat-form-field>

    <mat-form-field class="facilities-list-filter">
      <mat-label>Poczta</mat-label>
      <input matInput placeholder="Warszawa" name="contains$postCity" [(ngModel)]="initialFilters.contains$postCity">
    </mat-form-field>

    <mat-form-field class="facilities-list-filter">
      <mat-label>Kod pocztowy</mat-label>
      <input matInput placeholder="01-001" name="zipCode" [(ngModel)]="initialFilters.zipCode">
    </mat-form-field>

    <mat-form-field class="facilities-list-filter">
      <mat-label>Miejscowość</mat-label>
      <input matInput placeholder="Warszawa" name="contains$city" [(ngModel)]="initialFilters.contains$city">
    </mat-form-field>

    <mat-form-field class="facilities-list-filter">
      <mat-label>Powiat</mat-label>
      <input matInput placeholder="Warszawa" name="contains$district" [(ngModel)]="initialFilters.contains$district">
    </mat-form-field>

    <mat-form-field class="facilities-list-filter">
      <mat-label>Gmina</mat-label>
      <input matInput placeholder="Warszawa" name="contains$commune" [(ngModel)]="initialFilters.contains$commune">
    </mat-form-field>

    <app-dict
      [multiple]="true" [dictType]="'address_state'"
      [label]="'Województwo'" class="facilities-list-filter"
      [(ngModel)]="initialFilters.in$state" name="in$state"
    ></app-dict>

    <app-dict-regionals
      [noneEntry]="true" [multiple]="true"
      [label]="'Regionalny (majątek)'" class="facilities-list-filter"
      [(ngModel)]="initialFilters.assetsRegional" name="assetsRegional"
    ></app-dict-regionals>

    <app-dict-partners
      [multiple]="false" [label]="'Partner'"
      class="facilities-list-filter facilities-list-filter-partner"
      [(ngModel)]="initialFilters.partner" name="partner"
    ></app-dict-partners>

    <app-dict
      [multiple]="true" [dictType]="'facility_type'"
      [label]="'Typ placówki'" class="facilities-list-filter"
      [(ngModel)]="initialFilters.facilityType" name="facilityType"
    ></app-dict>

    <app-dict
      class="facilities-list-filter" [label]="'Tagi'"
      [dictType]="'partner_tags'"
      [required]="false" [multiple]="true"
      [(ngModel)]="initialFilters.tags" name="tags"
    ></app-dict>

    <mat-form-field  class="facilities-list-filter">
      <mat-label>Przeprowadzona kontrola</mat-label>
      <mat-select [(ngModel)]="initialFilters.inspectionCarried" name="inspectionCarried">
        <mat-option [value]="null">Wszyscy</mat-option>
        <mat-option [value]="1">Tak</mat-option>
        <mat-option [value]="0">Nie</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field  class="facilities-list-filter">
      <mat-label>Aktywne OFWCA</mat-label>
      <mat-select [(ngModel)]="initialFilters.activeOfwca" name="activeOfwca">
        <mat-option [value]="null">Wszyscy</mat-option>
        <mat-option [value]="1">Tak</mat-option>
        <mat-option [value]="0">Nie</mat-option>
      </mat-select>
    </mat-form-field>
  </form>

  <div class="facilities-list-buttons">
    <div class="pull-right">
      <button *ngIf="(userPermissions | async).facility.read_report" [disabled]="!(userPermissions | async).facility.read_report"
              mat-raised-button [matMenuTriggerFor]="generate" class="report-button">
        <mat-icon>download</mat-icon> Pobierz raport</button>
      <mat-menu #generate="matMenu">
        <button *ngIf="(userPermissions | async).facility.read_report" [disabled]="!(userPermissions | async).facility.read_report"  mat-menu-item (click)="downloadReport()">Pobierz raport </button>
        <button *ngIf="(userPermissions | async).facility.read_report" [disabled]="!(userPermissions | async).facility.read_report" mat-menu-item (click)="downloadVerificationReport()">Pobierz raport weryfikacji</button>
      </mat-menu>
<!--      <button (click)="downloadReport()" [disabled]="!(userPermissions | async).facility.read_report"-->
<!--              mat-raised-button class="report-button"><mat-icon>download</mat-icon> <span> Pobierz raport</span></button>-->
      <button (click)="filter()" mat-raised-button color="primary"><mat-icon>search</mat-icon> <span> Szukaj</span></button>
      <button (click)="resetFilters()" mat-raised-button color="warn"><mat-icon>delete</mat-icon> <span> Resetuj filtry</span></button>
    </div>
  </div>

  <table mat-table [dataSource]="dataSource">

    <!-- Position Column -->
    <ng-container matColumnDef="street">
      <th mat-header-cell *matHeaderCellDef> Ulica </th>
      <td mat-cell *matCellDef="let element">
        <a class="default-link" [routerLink]="['/placowki/szczegoly', element.address?.uuid]">{{element.address.street ? element.address.street : 'Brak nazwy ulicy'}}</a>
      </td>
    </ng-container>

    <ng-container matColumnDef="houseNumber">
      <th mat-header-cell *matHeaderCellDef> Numer budynku </th>
      <td mat-cell *matCellDef="let element">
        {{element.address.houseNumber}}
      </td>
    </ng-container>

    <ng-container matColumnDef="apartmentNumber">
      <th mat-header-cell *matHeaderCellDef> Numer mieszkania </th>
      <td mat-cell *matCellDef="let element">
        {{element.address.apartmentNumber}}
      </td>
    </ng-container>

    <ng-container matColumnDef="city">
      <th mat-header-cell *matHeaderCellDef> Miejscowość </th>
      <td mat-cell *matCellDef="let element">
        {{element.address.city}}
      </td>
    </ng-container>

    <ng-container matColumnDef="zipCode">
      <th mat-header-cell *matHeaderCellDef> Kod pocztowy </th>
      <td mat-cell *matCellDef="let element">
        {{element.address.zipCode}}
      </td>
    </ng-container>

    <ng-container matColumnDef="state">
      <th mat-header-cell *matHeaderCellDef> Województwo </th>
      <td mat-cell *matCellDef="let element">
        {{element.address.state?.name}}
      </td>
    </ng-container>

    <ng-container matColumnDef="partner">
      <th mat-header-cell *matHeaderCellDef> Partner </th>
      <td mat-cell *matCellDef="let element">
        <ng-container *ngFor="let partner of element.partners">
          <p><a class="default-link" [routerLink]="['/partnerzy/szczegoly', partner?.uuid]">{{partner?.shortName}}</a></p>
        </ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="assetsRegional">
      <th mat-header-cell *matHeaderCellDef> Regionalny (majątek) Partnera </th>
      <td mat-cell *matCellDef="let element">
        <ng-container *ngFor="let partner of element.partners">
          <p>{{partner?.assetsRegional?.firstName}} {{partner?.assetsRegional?.lastName}}</p>
        </ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="activeOfwcas">
      <th mat-header-cell *matHeaderCellDef> Aktywne OFWCA </th>
      <td mat-cell *matCellDef="let element">
        {{element.activeOfwcas}}
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element">
        <button mat-icon-button [matMenuTriggerFor]="menu"><mat-icon>expand_more</mat-icon></button>
        <mat-menu #menu="matMenu" xPosition="before">
          <button [disabled]="!(userPermissions | async).facility.delete" mat-menu-item (click)="deleteFacility(element)">Usuń</button>
        </mat-menu>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator [pageSizeOptions]="[10, 20, 50,]" [length]="totalData"></mat-paginator>
</div>
